import React from 'react';
import { adminRoute } from '@/modules/administration/routes';
import { createRoute } from '@tanstack/react-router';

export const adminIndexRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: '/',
  component: React.lazy(async () => await import('@/app/routes/Admin')),
});
